import React, { useState } from 'react';
import PencilIcon from '@heroicons/react/outline/PencilIcon.js';
import XIcon from '@heroicons/react/outline/XIcon.js';
import { Button } from '../Button/index.js';
import { ColorCircle, ColorPicker } from '../ColorPicker/index.js';
import { Input } from '../Input/index.js';
import { colorStyles } from './utils.js';
export const LabelPickerItem = ({ item, active, onEdit, onRemove, onCancel, setActive, placeholder, disabled, saveLabel, cancelLabel, }) => {
    const [inputValue, setInputValue] = useState(item.name);
    const [colorValue, setColorValue] = useState(item.colorHex);
    if (!active || disabled) {
        return (React.createElement("div", { className: "group flex space-s-2 items-center h-7" },
            React.createElement(ColorCircle, { size: "xs", color: colorValue, className: "shrink-0" }),
            React.createElement("div", { className: "grow truncate" }, item.name),
            !disabled && (React.createElement(React.Fragment, null,
                React.createElement(Button, { className: "bg-surface opacity-0 group-hover:opacity-100 focus-visible:opacity-100", variant: "basic", leadingIcon: React.createElement(PencilIcon, null), size: "xs", rounded: true, onClick: () => {
                        setActive(true);
                        setInputValue(item.name);
                        setColorValue(item.colorHex);
                    } }),
                React.createElement(Button, { className: "bg-surface opacity-0 group-hover:opacity-100 focus-visible:opacity-100", variant: "basic", leadingIcon: React.createElement(XIcon, null), size: "xs", rounded: true, onClick: onRemove })))));
    }
    const onSave = () => {
        if (!inputValue) {
            return;
        }
        onEdit({
            name: inputValue,
            colorHex: colorValue,
            id: item.id,
        });
    };
    const handleCancel = () => {
        setInputValue(item.name);
        setColorValue(item.colorHex);
        onCancel();
    };
    const onKeyDown = event => {
        if (event.key === 'Enter' && inputValue && !disabled) {
            onSave();
        }
        if (event.key === 'Escape') {
            handleCancel();
        }
    };
    return (React.createElement("div", { className: "group flex space-s-2 items-center" },
        React.createElement("div", { className: "shrink-0" },
            React.createElement(ColorPicker, { size: "sm", color: colorValue, onChange: value => setColorValue(value), variants: colorStyles })),
        React.createElement("div", { className: "grow" },
            React.createElement(Input, { value: inputValue, onChange: e => { var _a; return setInputValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value); }, className: "grow", placeholder: placeholder, autoFocus: true, onKeyDown: onKeyDown })),
        React.createElement(Button, { variant: "outline", size: "sm", onClick: handleCancel }, cancelLabel !== null && cancelLabel !== void 0 ? cancelLabel : 'Cancel'),
        React.createElement(Button, { variant: "primary", size: "sm", onClick: onSave, disabled: !inputValue }, saveLabel !== null && saveLabel !== void 0 ? saveLabel : 'Save')));
};
//# sourceMappingURL=LabelPickerItem.js.map